(function () {
  var form = document.querySelector('[data-ll-wholesale-form]');
  if (!form) return;

  var messageEl = form.querySelector('[data-ll-wholesale-body]');
  var textarea = form.querySelector('[data-ll-wholesale-message]');
  var charCount = form.querySelector('[data-ll-wholesale-char]');
  var uploadZone = form.querySelector('[data-ll-wholesale-upload]');
  var uploadInput = form.querySelector('[data-ll-wholesale-file]');
  var uploadName = form.querySelector('[data-ll-wholesale-file-name]');
  var consent = form.querySelector('[data-ll-wholesale-consent]');
  var consentWrap = form.querySelector('[data-ll-consent-wrap]');
  var summaryEl = form.querySelector('[data-ll-wholesale-summary]');
  var submitBtn = form.querySelector('[data-ll-wholesale-submit]');
  var submitLabel = form.querySelector('[data-ll-wholesale-submit-label]');
  var maxChars = 1000;
  var maxFileBytes = 5 * 1024 * 1024;
  var defaultSubmitLabel = submitLabel ? submitLabel.textContent.trim() : 'Submit Wholesale Request';

  var fieldRules = [
    { name: 'full_name', label: 'Full name', required: true },
    { name: 'business_name', label: 'Business/store name', required: true },
    { name: 'email', label: 'Email address', required: true, type: 'email' },
    { name: 'phone', label: 'Phone number', required: true },
    { name: 'business_type', label: 'Business type', required: true, type: 'select' },
    { name: 'years_in_business', label: 'Years in business', required: true, type: 'select' },
    { name: 'business_address', label: 'Business address', required: true },
    { name: 'products_interest', label: 'Products of interest', required: true, type: 'select' },
    { name: 'monthly_order', label: 'Average monthly order', required: true, type: 'select' },
    { name: 'message', label: 'Tell us more', required: true, minLength: 10 },
    { name: 'website', label: 'Website', required: false, type: 'url' }
  ];

  function val(name) {
    var el = form.querySelector('[data-field="' + name + '"]');
    return el && el.value ? el.value.trim() : '';
  }

  function fieldEl(name) {
    return form.querySelector('[data-field="' + name + '"]');
  }

  function fieldWrap(el) {
    if (!el) return null;
    return el.closest('.ll-wholesale__field') || el.closest('[data-ll-consent-wrap]');
  }

  function ensureErrorEl(wrap) {
    if (!wrap) return null;
    var errorEl = wrap.querySelector('[data-ll-field-error]');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'll-wholesale__field-error';
      errorEl.setAttribute('data-ll-field-error', '');
      errorEl.setAttribute('role', 'alert');
      wrap.appendChild(errorEl);
    }
    return errorEl;
  }

  function clearFieldError(el) {
    var wrap = fieldWrap(el);
    if (!wrap) return;
    wrap.classList.remove('is-invalid');
    if (el) el.removeAttribute('aria-invalid');
    var errorEl = wrap.querySelector('[data-ll-field-error]');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function showFieldError(el, message) {
    var wrap = fieldWrap(el);
    if (!wrap || !el) return;
    var errorEl = ensureErrorEl(wrap);
    wrap.classList.add('is-invalid');
    el.setAttribute('aria-invalid', 'true');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
  }

  function clearAllErrors() {
    if (summaryEl) {
      summaryEl.hidden = true;
      summaryEl.textContent = '';
    }
    form.querySelectorAll('[data-field]').forEach(clearFieldError);
    if (consentWrap) {
      consentWrap.classList.remove('is-invalid');
      var consentError = consentWrap.querySelector('[data-ll-field-error]');
      if (consentError) {
        consentError.textContent = '';
        consentError.hidden = true;
      }
    }
    if (uploadZone) uploadZone.classList.remove('is-invalid');
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function isValidUrl(value) {
    try {
      var url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
      return false;
    }
  }

  function validateRule(rule) {
    var el = fieldEl(rule.name);
    if (!el) return '';

    var value = el.value ? el.value.trim() : '';

    if (rule.required && !value) {
      if (rule.type === 'select') return 'Please select ' + rule.label.toLowerCase() + '.';
      return 'Please enter ' + rule.label.toLowerCase() + '.';
    }

    if (!value) return '';

    if (rule.type === 'email' && !isValidEmail(value)) {
      return 'Please enter a valid email address.';
    }

    if (rule.type === 'url' && !isValidUrl(value)) {
      return 'Please enter a valid website URL (include https://).';
    }

    if (rule.minLength && value.length < rule.minLength) {
      return 'Please enter at least ' + rule.minLength + ' characters.';
    }

    return '';
  }

  function validateAll() {
    clearAllErrors();
    var firstInvalid = null;
    var errorCount = 0;

    fieldRules.forEach(function (rule) {
      var el = fieldEl(rule.name);
      var message = validateRule(rule);
      if (message) {
        showFieldError(el, message);
        if (!firstInvalid) firstInvalid = el;
        errorCount += 1;
      }
    });

    if (consent && !consent.checked && consentWrap) {
      var consentError = ensureErrorEl(consentWrap);
      consentWrap.classList.add('is-invalid');
      consentError.textContent = 'Please agree to the Privacy Policy before submitting.';
      consentError.hidden = false;
      if (!firstInvalid) firstInvalid = consent;
      errorCount += 1;
    }

    if (uploadInput && uploadInput.files.length && uploadInput.files[0].size > maxFileBytes) {
      if (uploadZone) uploadZone.classList.add('is-invalid');
      var uploadWrap = uploadZone ? uploadZone.closest('.ll-wholesale__field') : null;
      if (uploadWrap) {
        var uploadError = ensureErrorEl(uploadWrap);
        uploadError.textContent = 'File must be 5MB or smaller.';
        uploadError.hidden = false;
      }
      if (!firstInvalid) firstInvalid = uploadInput;
      errorCount += 1;
    }

    if (errorCount && summaryEl) {
      summaryEl.textContent =
        errorCount === 1
          ? 'Please fix the highlighted field below.'
          : 'Please fix the ' + errorCount + ' highlighted fields below.';
      summaryEl.hidden = false;
    }

    if (firstInvalid) {
      firstInvalid.focus();
      if (firstInvalid.scrollIntoView) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }

    return true;
  }

  function initPhoneCodePickers() {
    var pickers = form.querySelectorAll('[data-ll-phone-code]');
    if (!pickers.length) return;

    function closeAll(except) {
      pickers.forEach(function (picker) {
        if (picker === except) return;
        var toggle = picker.querySelector('[data-ll-phone-code-toggle]');
        var list = picker.querySelector('[data-ll-phone-code-list]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (list) list.hidden = true;
      });
    }

    pickers.forEach(function (picker) {
      var toggle = picker.querySelector('[data-ll-phone-code-toggle]');
      var list = picker.querySelector('[data-ll-phone-code-list]');
      var hiddenInput = picker.querySelector('[data-ll-phone-code-input]');
      var emojiEl = picker.querySelector('[data-ll-phone-emoji]');
      var dialEl = picker.querySelector('[data-ll-phone-dial]');
      if (!toggle || !list || !hiddenInput) return;

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAll(picker);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        list.hidden = isOpen;
      });

      list.querySelectorAll('button[data-code]').forEach(function (option) {
        option.addEventListener('click', function () {
          var code = option.getAttribute('data-code');
          var name = option.getAttribute('data-name');

          hiddenInput.value = code;
          if (dialEl) dialEl.textContent = code;
          var optionEmoji = option.querySelector('.ll-wholesale__phone-emoji');
          if (emojiEl && optionEmoji) {
            emojiEl.textContent = optionEmoji.textContent;
          }

          list.querySelectorAll('button').forEach(function (btn) {
            btn.classList.remove('is-selected');
          });
          option.classList.add('is-selected');

          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Country code: ' + (name || code));
          list.hidden = true;
        });
      });

      var defaultOption = list.querySelector('button[data-iso="us"]');
      if (defaultOption) defaultOption.classList.add('is-selected');
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-ll-phone-code]')) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  initPhoneCodePickers();

  function updateCharCount() {
    if (!textarea || !charCount) return;
    if (textarea.value.length > maxChars) {
      textarea.value = textarea.value.slice(0, maxChars);
    }
    charCount.textContent = textarea.value.length + ' / ' + maxChars + ' characters';
    if (textarea.value.length > 0) clearFieldError(textarea);
  }

  if (textarea) {
    textarea.addEventListener('input', updateCharCount);
    updateCharCount();
  }

  form.querySelectorAll('[data-field]').forEach(function (el) {
    var eventName = el.tagName === 'SELECT' ? 'change' : 'input';
    el.addEventListener(eventName, function () {
      clearFieldError(el);
      if (summaryEl) summaryEl.hidden = true;
    });
    el.addEventListener('blur', function () {
      var rule = fieldRules.find(function (entry) {
        return entry.name === el.getAttribute('data-field');
      });
      if (!rule) return;
      var message = validateRule(rule);
      if (message) showFieldError(el, message);
    });
  });

  if (consent) {
    consent.addEventListener('change', function () {
      if (consent.checked && consentWrap) {
        consentWrap.classList.remove('is-invalid');
        var consentError = consentWrap.querySelector('[data-ll-field-error]');
        if (consentError) {
          consentError.textContent = '';
          consentError.hidden = true;
        }
        if (summaryEl) summaryEl.hidden = true;
      }
    });
  }

  if (uploadZone && uploadInput) {
    uploadZone.addEventListener('click', function () {
      uploadInput.click();
    });

    uploadZone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        uploadInput.click();
      }
    });

    uploadZone.addEventListener('dragover', function (event) {
      event.preventDefault();
      uploadZone.classList.add('is-dragover');
    });

    uploadZone.addEventListener('dragleave', function () {
      uploadZone.classList.remove('is-dragover');
    });

    uploadZone.addEventListener('drop', function (event) {
      event.preventDefault();
      uploadZone.classList.remove('is-dragover');
      if (event.dataTransfer && event.dataTransfer.files.length) {
        uploadInput.files = event.dataTransfer.files;
        showFileName();
      }
    });

    uploadInput.addEventListener('change', showFileName);
  }

  function showFileName() {
    if (!uploadName || !uploadInput || !uploadInput.files.length) return;
    uploadName.textContent = 'Selected: ' + uploadInput.files[0].name;
    if (uploadZone) {
      uploadZone.classList.remove('is-invalid');
      var uploadWrap = uploadZone.closest('.ll-wholesale__field');
      if (uploadWrap) {
        var uploadError = uploadWrap.querySelector('[data-ll-field-error]');
        if (uploadError) {
          uploadError.textContent = '';
          uploadError.hidden = true;
        }
      }
    }
  }

  function setSubmitting(isSubmitting) {
    if (!submitBtn) return;
    submitBtn.disabled = isSubmitting;
    submitBtn.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    if (submitLabel) {
      submitLabel.textContent = isSubmitting ? 'Submitting...' : defaultSubmitLabel;
    }
  }

  form.addEventListener('submit', function (event) {
    if (!validateAll()) {
      event.preventDefault();
      return;
    }

    if (!messageEl) return;

    var lines = [
      'Wholesale Request',
      '-------------------',
      '',
      'CONTACT INFORMATION',
      'Full Name: ' + val('full_name'),
      'Business/Store Name: ' + val('business_name'),
      'Email: ' + val('email'),
      'Phone: ' + val('phone_code') + ' ' + val('phone'),
      '',
      'BUSINESS INFORMATION',
      'Business Type: ' + val('business_type'),
      'Website: ' + (val('website') || 'N/A'),
      'Tax ID / VAT: ' + (val('tax_id') || 'N/A'),
      'Years in Business: ' + val('years_in_business'),
      'Business Address: ' + val('business_address'),
      '',
      'WHOLESALE DETAILS',
      'Products of Interest: ' + val('products_interest'),
      'Average Monthly Order (USD): ' + val('monthly_order'),
      'Where did you hear about us?: ' + (val('referral_source') || 'N/A'),
      '',
      'Tell us more:',
      val('message')
    ];

    if (uploadInput && uploadInput.files.length) {
      lines.push('', 'Document note: Customer selected "' + uploadInput.files[0].name + '" — please follow up for file.');
    }

    messageEl.value = lines.join('\n');
    setSubmitting(true);
  });

  var successNote = form.querySelector('.ll-wholesale__note--success');
  if (successNote) {
    successNote.scrollIntoView({ behavior: 'smooth', block: 'center' });
    form.reset();
    if (textarea && charCount) updateCharCount();
    if (uploadName) uploadName.textContent = '';
  }

  if (form.querySelector('[data-ll-wholesale-server-error]') && submitBtn) {
    setSubmitting(false);
  }
})();
